import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-xl font-bold mb-4">おかやま土木工事株式会社</h3>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                〒700-0000 岡山市北区○○町1-2-3
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                TEL: 086-012-3456
              </p>
              <p className="flex items-center">
                <i className="ri-printer-line mr-2"></i>
                FAX: 086-012-3457
              </p>
              <p className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                営業時間: 9:00〜18:00（日曜・祝日休み）
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">サイトマップ</h4>
            <ul className="space-y-2 text-gray-300">
              <li><Link to="/" className="hover:text-white transition-colors cursor-pointer">ホーム</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors cursor-pointer">事業内容</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors cursor-pointer">求人情報</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors cursor-pointer">ブログ・新着情報</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">主な事業</h4>
            <ul className="space-y-2 text-gray-300">
              <li>土木工事</li>
              <li>水道工事</li>
              <li>舗装工事</li>
              <li>外構工事</li>
              <li>造成工事</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 おかやま土木工事株式会社. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}